import { Component, OnDestroy, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FilterService } from '../../generic/service/filter.service';

/**
 * Simple component to modify the filter state with a pot height
 */
@Component({
    selector: 'filter-height',
    styleUrls: ['./filter.component.scss'],
    template: ` <div class="filter-bar-part filter-height">
        <h4 i18n="Height filter header@@product.feature.height">Height</h4>
        <form
            class="filter-range-form"
            [formGroup]="form"
            (ngSubmit)="onSubmit()">
            <input
                type="number"
                placeholder="From"
                i18n-placeholder="Filter from@@filter.from"
                autocomplete="off"
                [formControl]="form.controls['heightFrom']"
                min="0" />
            <input
                type="number"
                placeholder="To"
                i18n-placeholder="Filter to@@filter.to"
                autocomplete="off"
                [formControl]="form.controls['heightTo']"
                min="0" />

            <button
                class="button theme-btn-secondary"
                type="submit"
                i18n="filter submit button@@filter.submit.button">
                OK
            </button>
        </form>
    </div>`,
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule],
})
export class FilterHeightComponent implements OnDestroy {
    private filterService = inject(FilterService);
    private formBuilder = inject(UntypedFormBuilder);

    form: UntypedFormGroup;

    private filterStateChangedSubscription: Subscription;

    constructor() {
        const filterState = this.filterService.getFilterState();

        this.form = this.formBuilder.group({
            heightFrom: [filterState.heightFrom],
            heightTo: [filterState.heightTo],
        });

        this.filterStateChangedSubscription =
            this.filterService.filterStateChanged.subscribe(newState => {
                this.form.get('heightFrom')?.setValue(newState.heightFrom);
                this.form.get('heightTo')?.setValue(newState.heightTo);
            });
    }

    ngOnDestroy(): void {
        this.filterStateChangedSubscription.unsubscribe();
    }

    onSubmit() {
        const filterState = this.filterService.getFilterState();

        if (this.form.invalid) {
            return;
        }

        const formValues = this.form.value;

        // Check if one of the values has changed
        if (
            formValues.heightFrom !== filterState.heightFrom ||
            formValues.heightTo !== filterState.heightTo
        ) {
            this.filterService.setHeight(
                formValues.heightFrom,
                formValues.heightTo,
            );
        }
    }
}
